
import { VForm } from "vuetify/lib";

export default VForm.extend({});
